module.exports = __webpack_public_path__ + "img/2.2bf5a4ae.png";